import { Action, TableActions } from "../../../features/roles";
import { TableName } from '../../../tables'

export const ConstrufyAdminPolicyName = 'construfy.admin'
export const ConstrufyAdminRoleName = 'construfy.admin.role'

export const construfyAdminPermissions = (): TableActions[] => Object.values(TableName).map(tableName => (
    {
        tableName,
        actions: [
            Action.GET_ALL,
            Action.GET,
            Action.GET_BY_PARAMS,
            Action.GET_BY_IDS,
            Action.SAVE,
            Action.REMOVE
        ]
    }
))
